import dayjs from 'dayjs';
import {
  DemandModifierFormData,
  DemandModifierLocationType,
  DemandModifierTargetType,
  DemandModifierType,
} from '../types/DemandModifierTypes';

export const isDemandModifierFormValid = (formData: DemandModifierFormData): boolean => {
  if (!formData.name.trim()) return false;
  if (!formData.startDate || !formData.endDate) return false;
  const start = dayjs(formData.startDate);
  const end = dayjs(formData.endDate);
  if (!start.isValid() || !end.isValid()) return false;
  if (end.isBefore(start)) return false;

  if (formData.targetType === DemandModifierTargetType.SpecificCategories && formData.selectedCategories.length === 0) return false;
  if (formData.targetType === DemandModifierTargetType.SpecificSKUs && formData.selectedSKUs.length === 0) return false;

  if (formData.locationType === DemandModifierLocationType.SpecificFranchises && formData.selectedFranchises.length === 0) return false;
  if (formData.locationType === DemandModifierLocationType.SpecificStores && formData.selectedStores.length === 0) return false;

  if (
    formData.modifierType === DemandModifierType.PercentageUplift
    && (!Number.isFinite(formData.upliftPercentage) || formData.upliftPercentage === 0)
  ) return false;

  if (
    formData.modifierType === DemandModifierType.QuantityOffset
    && (!Number.isFinite(formData.quantityOffset) || formData.quantityOffset === 0)
  ) return false;

  return true;
};